export const DataHooks = {
  settingsTabLayout: 'settings-tab-layout',
  settingsMainTabButton: 'settings-main-tab-button',
  settingsAdUnitTabButton: 'settings-ad-unit-tab-button',
  settingsSupportTabButton: 'settings-support-tab-button',
  settingsMainTabContent: 'settings-main-tab-content',
  settingsAdUnitTabContent: 'settings-ad-unit-tab-content',
  settingsSupportTabContent: 'settings-support-tab-content',
  supportArticlesListHeader: 'support-articles-list-header',
  kbWixTechnicalAssistant: 'wix-technical-assistant',
  kbGoogleAdsenseSupport: 'google-adsense-support',
  kbContactCustomerCare: 'contact_customer_care',
  kbDuplicateAdUnit: 'how-to-duplicate-adunit',
  kbAddingAndSettingAdUnit: 'adding_and_setting_up_ads',
  kbConnectAdUnit: 'how_to_connect_ad_units',
  helpCenterHeader: 'help-center-header',
  helpCenterContent: 'help-center-content',
  kbSeeAllButton: 'kb-see-all-button',
  settingsMainTabDisconnected: 'settings-main-tab-disconnected',
  settingsMainTabInReview: 'settings-main-tab-in-review',
  settingsMainTabInReviewNotification:
    'settings-main-tab-in-review-notification',
  settingsMainTabConnectedEmptyList: 'settings-main-tab-connected-empty-list',
  settingsMainTabConnectedAdUnitNotConnected:
    'settings-main-tab-connected-ad-unit-not-connected',
  settingsMainTabConnectedAdUnitConnected:
    'settings-main-tab-connected-ad-unit-connected',
  createFirstAdunitContent: 'ad-unit-tab-create-first-adunit',
  adUnitsTabHeader: 'ad-unit-tab-header',
  adUnitsTabFooter: 'ad-unit-tab-footer',
  adsenseTitle: 'adsense-title',
  adsbygoogleScript: 'adsbygoogle-script',
  adsenseContainer: 'adsense-container',
  adsbygoogleIns: 'adsbygoogle-ins',
};
